export const MAIN_ORDER = 5;
/** a real river name: "แม่น้ำ…" but not a "แม่น้ำลัด…" shortcut channel */
export const isRiverName = (n) => !!n && /^แม่น้ำ/.test(n) && !/^แม่น้ำลัด/.test(n);
/** reachId → upstream reach ids (build once per graph). */
export function upstreamIndex(graph) {
    const up = new Map();
    for (const [id, t] of Object.entries(graph)) {
        const next = t[0];
        if (!next)
            continue;
        const l = up.get(next);
        if (l)
            l.push(Number(id));
        else
            up.set(next, [Number(id)]);
    }
    return up;
}
/** "แม่น้ำโขง / ແມ່ນ້ຳຂອງ" → "แม่น้ำโขง" (first, Thai, form). */
const clean = (n) => { const s = (n ?? "").split(" / ")[0].trim(); return s || null; };
export function mainRiverName(graph, names, reachId, up, maxReaches = 4000) {
    const t0 = graph[String(reachId)];
    const own = clean(names[String(reachId)]);
    if (!t0)
        return { name: own, main: null, own, stretchKm: 0 };
    if (isRiverName(own))
        return { name: own, main: own, own, stretchKm: 0 }; // its own "แม่น้ำ…" name wins
    const ord = t0[3];
    if (ord < MAIN_ORDER)
        return { name: own, main: null, own, stretchKm: 0 };
    const km = new Map();
    let total = 0, n = 0;
    const add = (id) => {
        const t = graph[String(id)];
        total += t[1];
        n++;
        const nm = clean(names[String(id)]);
        if (nm)
            km.set(nm, (km.get(nm) ?? 0) + t[1]);
    };
    add(reachId);
    // downstream while the order stays the same
    const seen = new Set([reachId]);
    for (let cur = t0[0]; cur && graph[String(cur)] && graph[String(cur)][3] === ord && !seen.has(cur) && n < maxReaches; cur = graph[String(cur)][0]) {
        seen.add(cur);
        add(cur);
    }
    // upstream along the same-order inflow carrying the most water
    for (let cur = reachId; n < maxReaches;) {
        const cands = (up.get(cur) ?? []).filter((id) => graph[String(id)][3] === ord && !seen.has(id));
        if (!cands.length)
            break;
        cur = cands.reduce((a, b) => (graph[String(b)][2] > graph[String(a)][2] ? b : a));
        seen.add(cur);
        add(cur);
    }
    let main = null, best = 0;
    for (const [nm, k] of km)
        if (k > best) {
            best = k;
            main = nm;
        }
    return { name: main ?? own, main, own, stretchKm: Math.round(total) };
}
//# sourceMappingURL=river-name.js.map